import { render, staticRenderFns } from "./tarifsvideo.vue?vue&type=template&id=f9061006&"
import script from "./tarifsvideo.vue?vue&type=script&lang=js&"
export * from "./tarifsvideo.vue?vue&type=script&lang=js&"
import style0 from "./tarifsvideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports